//This file is automatically rebuilt by the Cesium build process.
export default "bool czm_isEmpty(czm_raySegment interval)\n\
{\n\
return (interval.stop < 0.0);\n\
}\n\
";
